export const imageData = [
  require("../../assets/mobile/1.png"),

  require("../../assets/mobile/2.png"),

  require("../../assets/mobile/3.png"),

  require("../../assets/mobile/4.png"),

  require("../../assets/mobile/5.png"),
];

export const imageData2 = [
  require("../../assets/mobile/6.png"),

  require("../../assets/mobile/7.png"),

  require("../../assets/mobile/8.png"),
];
